import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AfmOtherService = /** @class */ (function () {
    function AfmOtherService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * updates specified entity via api
     * @param {number} airportID
     * @param {AfmOther} afmOther
     * @return {Promise<any>}
     */
    AfmOtherService.prototype.putAfmOther = function (airportID, afmOther) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/afmOther";
        try {
            var BODY = this._getAfmOtherJSON(afmOther);
            return this._http.put(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * converts entity to json obj
     * @param {AfmOther} afmOther
     * @return {any}
     * @private
     */
    AfmOtherService.prototype._getAfmOtherJSON = function (afmOther) {
        return {
            websiteUrl: afmOther.websiteUrl,
            lightWindRwy: afmOther.lightWindRwy,
            gatParking: afmOther.gatParking,
            gatCharted: afmOther.gatCharted,
            gatDescription: afmOther.gatDescription
        };
    };
    AfmOtherService.ngInjectableDef = i0.defineInjectable({ factory: function AfmOtherService_Factory() { return new AfmOtherService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: AfmOtherService, providedIn: "root" });
    return AfmOtherService;
}());
export { AfmOtherService };
